var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "width": "47",
      "height": "47",
      "viewBox": "0 0 47 47",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "clip-path": "url(#cookie_svg__clip0_518918_813)",
      "stroke": "#2FB292",
      "stroke-width": "3"
    }
  }, [_c('path', {
    attrs: {
      "d": "M41.104 17.615a7.335 7.335 0 01-7.34-7.381 7.277 7.277 0 01-7.893.63A7.339 7.339 0 0122.607 1.5a22.008 22.008 0 1021.851 15.275 7.262 7.262 0 01-3.354.839z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.635 24.947a4.406 4.406 0 100-8.812 4.406 4.406 0 000 8.812zM27.853 36.697a2.938 2.938 0 100-5.875 2.938 2.938 0 000 5.875z",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.904 33.76a.734.734 0 110-1.469M13.904 33.76a.734.734 0 000-1.469M25.65 20.541a.734.734 0 110-1.469M25.65 20.541a.734.734 0 100-1.469M37.4 26.416a.734.734 0 010-1.469M37.4 26.416a.734.734 0 100-1.469"
    }
  })]), _c('defs', [_c('clipPath', {
    attrs: {
      "id": "cookie_svg__clip0_518918_813"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#fff",
      "d": "M0 0h47v47H0z"
    }
  })])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }